var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import Flex from "@irati/ui/src/Flex";
import { Hr } from "@irati/ui/src/Layout";
import { H4 } from "@irati/ui/src/Typography";
import BirthdayBoxCard from "./Card";
var StyledCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  float: none;\n"], ["\n  display: inline-block;\n  float: none;\n"])));
var BirthdayBox = function (_a) {
    var metadata = _a.metadata, props = __rest(_a, ["metadata"]);
    var idNamespace = id("birthday-box-list", props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Hr, { large: true }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Flex, { margin: [0, 0, 3, 0] },
                    React.createElement(H4, { marginBottom: 2 },
                        React.createElement(FormattedMessage, { id: "perks.components.birthdayBox.title" }))))),
        React.createElement(Row, null, metadata.map(function (boxMetadata, index) { return (React.createElement(StyledCol, { key: "column-" + boxMetadata.productId, id: id("column-" + index, idNamespace), xs: 12, sm: 6, md: 4 },
            React.createElement(BirthdayBoxCard, { metadata: boxMetadata }))); }))));
};
export default BirthdayBox;
var templateObject_1;
